import {
  CLIENT_SCREEN,
  CLIENT_SCREEN_SUCCESS,
  PROJECT_LISTS,
  PROJECT_LISTS_ERROR,
  PROJECT_LISTS_SUCCESS,
  STORE_TIMELOGBYDATE,
  WORK_SCREEN,
  WORK_SCREEN_SUCCESS,
  STORE_ACTIVITYLOGBYDATE,
} from "./actionType"

const initialState = {
  timelogentry: [],
  activitylogentry: [],
}

const workteam = (state = initialState, action) => {
  switch (action.type) {
    case PROJECT_LISTS:
      state = {
        ...state,
        projectListsSuccess: null,
        projectListsError: null,
      }
      break

    case PROJECT_LISTS_SUCCESS:
      state = {
        ...state,
        projectListsSuccess: action.payload,
        projectListsError: null,
      }
      break

    case PROJECT_LISTS_ERROR:
      state = { ...state, projectListsError: action.payload }
      break
    // category work screen
    case WORK_SCREEN:
      state = {
        ...state,
        workscreenSuccessList: null,
        workscreenError: null,
      }
      break

    case WORK_SCREEN_SUCCESS:
      state = {
        ...state,
        workscreenSuccessList: action.payload,
        workscreenError: null,
      }

    //client screen view
    case CLIENT_SCREEN:
      state = {
        ...state,
        clientscreenSuccessList: null,
        clientscreenError: null,
      }
      break

    case CLIENT_SCREEN_SUCCESS:
      state = {
        ...state,
        clientscreenSuccessList: action.payload,
        clientscreenError: null,
      }
      break
    case STORE_TIMELOGBYDATE:
      state = {
        ...state,
        timelogentry: action.payload,
      }
      break
    case STORE_ACTIVITYLOGBYDATE:
      state = {
        ...state,
        activitylogentry: action.payload,
      }
      break
    // gethours summary
    default:
      state = { ...state }
      break
  }
  return state
}

export default workteam
